import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <AboutSection />
        <IndexSection />
        <FeaturesSection />
        <TopicsSection />
        <MediaSection />
        <RankingSection />
        <ContactSection />
        <FaqSection />
        <UpdatesSection />
        <CardsSection />
        <CommentsSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}